import { useState } from 'react';

const LS_KEY = 'fp_glossary_hint_dismissed';

/**
 * GlossaryHint — banner pequeño dentro del Oraculo que explica al usuario
 * que las palabras subrayadas son clickeables. Aparece solo si nunca lo
 * cerro (localStorage flag fp_glossary_hint_dismissed).
 *
 * Diseno minimalista: una linea sutil que no compite visualmente con el
 * Hero audio. Dismissible con X o con click en cualquier palabra subrayada
 * (el GlossaryTerm tambien dispara el dismiss para que no quede mostrandose
 * por siempre — el usuario ya entendio).
 */
export default function GlossaryHint({ onDismiss }) {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(LS_KEY) === '1'; } catch { return false; }
  });

  if (dismissed) return null;

  const dismiss = () => {
    try { localStorage.setItem(LS_KEY, '1'); } catch {}
    setDismissed(true);
    if (onDismiss) onDismiss();
  };

  return (
    <div className="bg-[#F0FDF4] border border-[#86EFAC] rounded-lg px-3 py-2 mb-3 flex items-center gap-2 text-xs">
      <span className="text-base flex-shrink-0">💡</span>
      <span className="flex-1 text-[#14532D] leading-snug">
        Las palabras con <span className="border-b border-dotted border-[#059669] text-[#059669] font-semibold px-0.5">subrayado punteado</span> tienen definición. Tócalas para entenderlas.
      </span>
      <button
        onClick={dismiss}
        aria-label="Entendido"
        className="text-[#059669] hover:text-[#047857] text-base flex-shrink-0"
        type="button"
      >
        ×
      </button>
    </div>
  );
}
